import {configureStore} from '@reduxjs/toolkit';
import  {visaCardSlice} from './VisaCard/VisaCardReducer';
import { testimonialCardSlice } from './Testimonial/TestimonialCardReducer';
import { visaDetailSlice } from './Visa/VisaReducer';
import { verifySlice } from './Verify/VerifyReducer';
import { addOnsSlice } from './AddOn/AddOnReducer';
import { userSlice } from './User/UserReducer';
import { passportSlice } from './Passport/PassportReducer';
import { visaAppliedSlice } from './VisaApplied/VisaAppliedReducer';
import { paymentSlice } from './Payment/PaymentReducer';

const Store = configureStore({
    reducer:{
        visaCards: visaCardSlice.reducer,
        testimonialCards: testimonialCardSlice.reducer,
        visaDetail: visaDetailSlice.reducer,
        verify: verifySlice.reducer,
        addOns: addOnsSlice.reducer,
        user: userSlice.reducer,
        passport : passportSlice.reducer,
        visaApplied : visaAppliedSlice.reducer,
        payment: paymentSlice.reducer
    }
});
export default Store;